// Age gate (local-only). Shows Figma-matched overlay until user confirms 18+.
(function () {
  const STORAGE_KEY = 'age_verified';
  const COOKIE_KEY = 'age_verified';
  const MAX_AGE_SECONDS = 60 * 60 * 24 * 3; // 3 days

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value) {
    let cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${MAX_AGE_SECONDS}; samesite=lax`;
    if (window.location && window.location.protocol === 'https:') cookie += '; secure';
    document.cookie = cookie;
  }

  function isVerified() {
    try {
      const v = window.localStorage.getItem(STORAGE_KEY);
      if (v === '1' || v === 'true') return true;
    } catch (e) {}

    const c = getCookie(COOKIE_KEY);
    return c === '1' || c === 'true';
  }

  function setOpen(overlay, open) {
    overlay.classList.toggle('is-open', open);
    overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  document.addEventListener('DOMContentLoaded', function () {
    const overlay = document.querySelector('[data-age-gate]');
    if (!overlay) return;

    const acceptBtn = overlay.querySelector('[data-age-gate-accept]');
    if (!acceptBtn) return;

    if (isVerified()) {
      setOpen(overlay, false);
      document.body.classList.remove('has-age-gate');
      return;
    }

    setOpen(overlay, true);
    document.body.classList.add('has-age-gate');

    acceptBtn.addEventListener('click', function () {
      try {
        window.localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}

      setCookie(COOKIE_KEY, '1');
      setOpen(overlay, false);
      window.setTimeout(function () {
        document.body.classList.remove('has-age-gate');
      }, 260);
    });
  });
})();

